"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("../../styles");

var Calendar_1 = require("../Calendar");

function CalendarPopup(props) {
  var classes = styles_1.useStyles(exports.createStyles).classes;
  return react_1.default.createElement("div", {
    className: classes.root,
    tabIndex: -1
  }, react_1.default.createElement(Calendar_1.Calendar, __assign({}, props)));
}

exports.CalendarPopup = CalendarPopup;

exports.createStyles = function (theme) {
  return {
    root: {
      background: theme.pallete.surface.main,
      boxShadow: theme.shadows.outer[40],
      borderRadius: theme.radius.popper,
      padding: '0.5rem .25rem .25rem .25rem',
      outline: 'none'
    }
  };
};